import { DataRequirements, } from "../data.requirements";
import * as i0 from "@angular/core";
import * as i1 from "../data.requirements";
export class LoginUseCase {
    constructor(data) {
        this.data = data;
    }
    run() {
        return this.data.loginParent();
    }
}
LoginUseCase.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function LoginUseCase_Factory() { return new LoginUseCase(i0.ɵɵinject(i1.DataRequirementsInjectionToken)); }, token: LoginUseCase, providedIn: "root" });
